'use strict';

var MultiSelectComboboxKeyHandlersFactory = function MultiSelectComboboxKeyHandlersFactory(multiSelectComboboxService) {
  var mixin = {
    onArrowHandler: function onArrowHandler(event) {
      event.preventDefault();
      //var next;
      if (event.keyCode === 40) {
        this.virtualScrollingHelper.setNextActiveElement();
      } else {
        this.virtualScrollingHelper.setPrevActiveElement();
      }
    },
    onTabHandler: function onTabHandler() {
      this.hideDropdown();
      this.onDropdownHidden();
    },
    onKeyPressHandler: function onKeyPressHandler(event) {
      if (!this.isDropdownVisible) {
        this.showDropdown();
      }
      switch (event.keyCode) {
        // Enter
        case 13:
          this.onEnterHandler(event);
          break;
        // Up arrow, down arrow
        case 38:
        case 40:
          this.onArrowHandler(event);
          break;
        // Tab key
        case 9:
          this.onTabHandler();
          break;
      }
    },
    selectElementsByInput: function selectElementsByInput(values) {
      if (this.prevSelectedValuesString === values) {
        return;
      }
      this.prevSelectedValuesString = values;
      var valuesArray = values.split(',');
      valuesArray.pop();
      multiSelectComboboxService.selectAll(this.comboboxElements, false);
      this.wrongValues = multiSelectComboboxService.selectElements(valuesArray, this.comboboxElements, this.selectionLimit);
      this.updateDataModel();
    },
    filterElements: function filterElements(value) {
      value = value.trim();
      this.visibleComboboxElements = [];
      if (value === '') {
        this.visibleComboboxElements = multiSelectComboboxService.showAllComboboxElements(this.comboboxElements, this.selectAllElement, this.selectionLimit);
        return null;
      } else {
        return multiSelectComboboxService.filterComboboxElements(value, this.comboboxElements, this.visibleComboboxElements);
      }
    },
    onInputHandler: function onInputHandler() {
      var value = this.inputDomElement.val();
      var lastCommaIndex = value.lastIndexOf(',');
      var filterValue = value.substr(lastCommaIndex + 1);
      var selectedElementsValues = value.substr(0, lastCommaIndex + 1);
      this.selectElementsByInput(selectedElementsValues);
      var activeElementIndex = this.filterElements(filterValue);
      this.updateDataModel();
      var allCheckboxesSelected = !!this.selectedValues && this.selectedValues.length === this.comboboxElements.length;
      this.selectAllElement.selected = allCheckboxesSelected;
      this.virtualScrollingHelper.render(this.visibleComboboxElements);
      this.toggleDisability();
      this.virtualScrollingHelper.setActiveElementByIndex(activeElementIndex);
    },
    onEnterHandler: function onEnterHandler(event) {
      event.preventDefault();
      this.virtualScrollingHelper.selectActiveElement();
      this.silentFocus = true;
      this.inputDomElement.blur().focus();
      this.silentFocus = false;
    }
  };
  return mixin;
};
MultiSelectComboboxKeyHandlersFactory.$inject = ['MultiSelectComboboxService'];
module.exports = MultiSelectComboboxKeyHandlersFactory;